import LazyLoad from "vanilla-lazyload";

document.addEventListener("DOMContentLoaded", function(event) {
    var lazyLoadInstance = new LazyLoad({
        elements_selector: "img.lazy",
        cancel_on_exit: false
    });
});
